import { render, staticRenderFns } from "./ResetPWDone.vue?vue&type=template&id=2608cfcd&"
import script from "./ResetPWDone.vue?vue&type=script&lang=js&"
export * from "./ResetPWDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports